export const DEFAULT_APP_CULTURE_CODE = 'en-US';